export const CommonDatagridSx = {
  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
    {
      display: "none",
    },
  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
    py: "8px",
  },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
    py: "15px",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
    py: "22px",
  },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cellCheckbox": {
    pl: "0px",
    py: "5.5px",
  },
  "&.MuiDataGrid-root--densityStandard .MuiOutlinedInput-root": {
    py: "5.5px",
  },
  ".action-cell": {
    paddingTop: "5px !important",
    paddingBottom: "5px !important",
  },
};

export const CommonLoaderBackdropSx = {
  color: "#fff",
  zIndex: (theme) => theme.zIndex.drawer + 1,
};
